module.exports = __webpack_public_path__ + "img/图标8.28487c70.png";